export default "__VITE_ASSET__hQrkvqcp__"